import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { RootState } from 'reducers/rootReducer'
import { subscribe } from 'actions/landing.action'
import { PricingPlans } from 'screens/Landing/Pricing/usePricing'
import IUserInfo from 'models/IUserInfo'

export interface PricingModalProps {
  title: string
  plan: PricingPlans
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  handlePlanChange: (plan: PricingPlans) => void
}

export const usePricingModal = (props: PricingModalProps) => {
  const { plan } = props

  const [name, setName] = useState('')
  const [restaurantName, setRestaurantName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [isPoliciesAccepted, setIsPoliciesAccepted] = useState(false)

  const dispatch = useAppDispatch()

  const isLoading: boolean = useSelector(
    (state: RootState) => state.landing.isLoading
  )
  const isSubscribeSuccess: boolean | null = useSelector(
    (state: RootState) => state.landing.isSubscribeSuccess
  )
  const subscribeResponseMessage: string | null = useSelector(
    (state: RootState) => state.landing.subscribeResponseMessage
  )

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (isPoliciesAccepted) {
      const userInfo: IUserInfo = {
        plan,
        name,
        restaurantName,
        email,
        phone,
      }

      dispatch(subscribe(userInfo))
    }
  }

  useEffect(() => {
    if (isSubscribeSuccess) {
      setName('')
      setRestaurantName('')
      setEmail('')
      setPhone('')
      setIsPoliciesAccepted(false)
    }
  }, [isSubscribeSuccess])

  return {
    ...props,
    name,
    restaurantName,
    email,
    phone,
    isPoliciesAccepted,
    isLoading,
    isSubscribeSuccess,
    subscribeResponseMessage,
    setName,
    setRestaurantName,
    setEmail,
    setPhone,
    setIsPoliciesAccepted,
    onSubmit,
  }
}
